export default {
  areas: [],
  area: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
